import qs from 'qs'
import { IRequestCourseModel } from 'models/requestCourse.model'
import api from '..'

export type ResponseRequestCourses = IRequestCourseModel[]

interface Response {
  data: {
    attributes: IRequestCourseModel
  }[]
}

export type Query = Record<string, any>

const admin = (q?: Query): Promise<ResponseRequestCourses> => {
  return api
    .get<Response>(`outsides_courses/admin?${qs.stringify({ q })}`)
    .then(({ data }) => data)
    .then(({ data }) => data.map(({ attributes: atributes }) => atributes))
}

export default admin
